/**
 * @example
 * twoDigit(3)   => 03
 * twoDigit(13)  => 13
 * @param value
 * @returns {string}
 */
export const twoDigit = (value: number) => (value > 9 ? value : `0${value}`);

/**
 * Check if number it's between min & max value
 * @param value
 * @param minValue
 * @param maxValue
 * @param {boolean} strict Allow value
 * @returns {boolean}
 */
export const isBetween = (
    value: number,
    minValue: number,
    maxValue: number = Number.MAX_SAFE_INTEGER,
    strict = true,
): boolean => (strict ? value > minValue && value < maxValue : value >= minValue && value <= maxValue);

/**
 * Get number between min & max values
 * based on logic formula `min <= size <= max`
 * @example
 * between(2, 12, 48) // result 12, because 12 <= 2 <= 48, it's false so we will get there min value
 * between(24, 12, 48) // result 24, because 12 <= 24 <= 48, it's true so we will get size value
 * between(65, 12, 48) // result 48, because 12 <= 65 <= 48, it's false so we will get there max value
 * @param size
 * @param min
 * @param max
 */
export const between = (size: number, min: number, max = 65536): number =>
    Math.min(Math.max(typeof size === 'undefined' ? min : size, min), max);
